import { useState } from 'react'

import { Box, useBreakpoint } from '@factorialco/deprecated-design-system'
import { Hub } from '@factorialco/f0-react/icons/app'
import { ModulesDatoModule } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import { useModuleAvailabilities } from 'modules/core/hooks/useModuleAvailabilities'

import Card from 'modules/marketplace_modules/components/PromotionContent/_Card'
import Header from 'modules/marketplace_modules/components/PromotionContent/_Header'
import { useGetDatoModules } from 'modules/marketplace_modules/hooks/useGetDatoModules'
import { getDatoLocale } from 'modules/onboarding/lib/datoLocale'

const PromotionContent = () => {
  const { breakpoint, isMobile } = useBreakpoint()
  const smallScreen = ['xs', 's', 'm', 'l', 'xl']
  const isSmallScreen = isMobile || smallScreen.includes(breakpoint)

  const [modulesUnavailable, setModulesUnavailable] = useState<ModulesDatoModule[]>([])

  const { moduleAvailabilities } = useModuleAvailabilities()

  const {
    access: { locale: accessLocale },
  } = useCurrentSession()

  const locale = getDatoLocale(accessLocale)
  const { data: modulesData } = useGetDatoModules({
    locale: locale,
  })

  const isModuleUnavailable = (chargebeeModuleName: string) => {
    const availableModule = moduleAvailabilities.filter((obj) => {
      const modulesArray = chargebeeModuleName?.split(',')
      return modulesArray?.includes(obj.id)
    })[0]

    return !(availableModule?.available ?? false)
  }

  useUnsafeEffect(() => {
    if (modulesData) {
      const unavailableModules: ModulesDatoModule[] = []
      modulesData.forEach((module) => {
        const unavailableModule = isModuleUnavailable(module.chargebeeModuleName || '')
        if (unavailableModule) {
          unavailableModules.push(module)
        }
      })
      setModulesUnavailable(unavailableModules)
    }
  }, [modulesData])

  return (
    <Box
      style={{
        background:
          'linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(255,255,255,0.3) 30%, rgba(240,240,245,0.7) 50%, rgba(245,245,250,0.85) 70%, rgba(250,250,252,0.95) 100%), linear-gradient(90deg, #0a0612 0%, #1a0e1f 30%, #3d1628 60%, #6b2538 100%)',
        height: '100vh',
        minWidth: isSmallScreen ? '100%' : '80%',
        maxWidth: isSmallScreen ? '100%' : '80%',
        margin: '0 auto',
      }}
      padding="s48"
      borderRadius={{ all: 'abs016' }}
      gap="s48"
    >
      <Header />
      <Box flexDirection="row" gap="s24" flexWrap="wrap">
        {modulesUnavailable.map((module) => (
          <Card
            key={module.id}
            title={module.name || ''}
            description={module.shortDescription || ''}
            isHeaderCard={false}
            // TODO: Use module icon
            icon={Hub}
            slug={module.slug || ''}
          />
        ))}
      </Box>
    </Box>
  )
}

export default PromotionContent
